// @ts-ignore
import * as errorToolTip from '../../general/errorToolTip.js';
import * as validators from '../../general/modules/validators';
import { disableJsFormHandler } from '../../general/modules/jsForm';
import { GtmSender } from '../../marketing/GtmSender';
import { SystemEvents } from '../../constants/gameEvents';
import { JsFormResponseHandlerObject } from '../../general/modules/jsFormTypes';
import { JsonRpcResponseFactory } from '../../general/modules/jsonRpc/jsonRpcResponseFactory';
import { JRpcErrResponse } from '../../general/modules/jsonRpc/jRpcErrResponse';
import { CurrentPage } from '../../pages/currentPage';
import { configureHttpAuth } from '../../startup/configureHttpAuth';
import { JRpcSuccResponse } from '../../general/modules/jsonRpc/jRpcSuccResponse';
import { Localization } from '../../localization/localization';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
window.app.registrationInteractiveBattleBefore = function registrationInteractiveBattleBefore(data: any) {
    const $termsCheckbox = $('.js-terms_agree', data.form);
    const $email = $('input[name=email]', data.form);
    const $password = $('input[name=password]', data.form);
    const $fieldContainers = $('.container__dialog-finish');

    window.$errorTooltip.hide();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let $errorField: any = false;
    let message: string;

    if (!validators.isValidEmail($email.val() as string)) {
        $errorField = $email;
        message = Localization._n('wrong_data');
    }

    if ($password.length) {
        if (($password.val() as string).trim() === '') {
            $errorField = $password;
            message = Localization._n('pass_empty');
        }
    }

    if ($termsCheckbox.length && !$termsCheckbox.hasClass('checked')) {
        $errorField = $termsCheckbox;
        message = Localization._n('agree_error');
    }

    if ($errorField) {
        $fieldContainers.hide();
        $errorField.closest('.container__dialog-finish').show();

        errorToolTip(
            $errorField,
            0,
            message,
            true
        );

        return false;
    }

    return true;
};

type RegistrationResponse = {
    registered: boolean,
    huid: number
};


async function registrationInteractiveBattleHandler(data: JsFormResponseHandlerObject<RegistrationResponse>) {
    const response = (new JsonRpcResponseFactory<RegistrationResponse>()).getJsonRpcResponseFromObject(data.response);

    if (response instanceof JRpcErrResponse) {
        const errorField = $('[type=submit]');

        errorField.addClass('error');
        errorToolTip(errorField, 0, response.error.message);
        return;
    }

    if (response instanceof JRpcSuccResponse) {
        window.app.user_huid = response.result.huid;
        configureHttpAuth();
        GtmSender.fireMarketing(SystemEvents.EMAIL_REG_SUCCESS);
        disableJsFormHandler(data.form);
        CurrentPage.reload();
    }
}


window.app.registrationInteractiveBattleHandler = registrationInteractiveBattleHandler;
